/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IClasificaciones from 'Infotrack@Modelos/smartStock/clasificaciones/entidades/clasificaciones';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import ClasificacionesCM from '../controladorModelo/clasificacionesCM';
import { IFormularioClasificacionesCVProps } from '../interfaces';
import { acciones, IEstadoClasificaciones } from '../reductorClasificaciones';
import FormularioClasificacionesVista from '../vista/formularioClasificacionesVista';
import { useSelector } from 'react-redux';

const estadoInicial: IClasificaciones = {
    EmpresaId: '',
    ClasificacionDescripcion: '',
    Estado: 1,
    AgenciaId: '',
};
const clasificacionesCM = new ClasificacionesCM();

const FormularioClasificacionesCV: React.FunctionComponent<IFormularioClasificacionesCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadClasificaciones }, dispatch] = useProveedor<
        IEstadoClasificaciones
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IClasificaciones>(estadoInicial);

    React.useEffect(() => {
        if (entidadClasificaciones && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadClasificaciones);
        } else {
            reiniciar();
        }
    }, [entidadClasificaciones]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionClasificaciones = () => {
        if (clasificacionesCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarClasificaciones,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarClasificaciones = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            clasificacionesCM
                .crearClasificaciones({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            clasificacionesCM
                .editarClasificaciones({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioClasificacionesVista
            accionCrearEditar={confirmarCreacionEdicionClasificaciones}
            cambiarInfoFomulario={alCambiarValor}
            clasificaciones={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioClasificacionesCVProps => ({ IdEmpresa: usuarioInformacion!.IdEmpresa });

export default connect<IFormularioClasificacionesCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioClasificacionesCV);
